import React from 'react'
import { MaxValueLabel, SliderC, SliderWrapper } from '~/pages/Farmer/Survey/RequestEntries/AnswerForms/Slider'
import styled, { CSSProperties } from 'styled-components'
import { useFormContext, useWatch } from 'react-hook-form'

interface Props {
  name: string
  label: string
  index: number
  infoContent?: string
  max?: number
  step?: number
  minWidth?: CSSProperties['minWidth']
}

const SliderLabel = styled.div`
  text-align: left;
  font-weight: 700;
  color: rgb(94, 102, 114);
  margin-bottom: 7px;
  display: flex;
  align-items: center;
  gap: 5px;
`

const SliderContainer = styled.div<{$minWidthSlider?: CSSProperties['minWidth']}>`
  margin-bottom: 10px;
  min-width: ${props => props.$minWidthSlider || '300px'};
`

const NPKSlider: React.FC<Props> = ({ name, label, index, infoContent, max = 100, step = 1, minWidth }) => {
  const { control, setValue } = useFormContext()
  const value = useWatch({ control, name: `fertilizers[${index}].${name}` })

  return (
    <SliderContainer $minWidthSlider={minWidth}>
      <SliderLabel dangerouslySetInnerHTML={{ __html: label }}/>
      <SliderWrapper>
        <SliderC
          step={step}
          rating={parseInt(value) || 0}
          min={0}
          max={max}
          value={value || 0}
          onChange={(e) => setValue(`fertilizers[${index}].${name}`, e.target.value)}
        />
        <MaxValueLabel style={{ fontWeight: 'normal' }}>{`${parseInt(value) || 0}%`}</MaxValueLabel>
      </SliderWrapper>
    </SliderContainer>
  )
}

export default NPKSlider
